// @flow
import React from 'react';

type Props = {
    headline: string
};

export default function Headliner({headline}: Props) {
    return (
        <header>
            {/* Keep h1 tag for SEO purposes */}
            <h1 className="HeadlineWithBreadcrumbs__headline">{headline}</h1>
        </header>
    );
}
